module.exports = __webpack_public_path__ + "static/media/hero.8021b1f9.jpg";